module.exports = __webpack_public_path__ + "img/1banner@2x.e418d6e4.png";